var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"fill":_vm.iconColor,"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"none","viewBox":_vm.viewBox}},[_c('g',[_c(_vm.iconType,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }